import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { GeoPoint } from '@core/models/geo.state';
import { StoreState, StoreWithDistanceState } from '@core/models/store.state';

/**
 * Store contract (HLD §17 `MarketplaceStore`). `nearby` implements the
 * store-granular Local Finds geo step (HLD §7.1 - Haversine over the store
 * set, listings then filter by StoreId).
 */
export interface StoreRepository {
  getById(id: number): Observable<StoreState | null>;
  listByTenant(tenantId: number): Observable<StoreState[]>;
  nearby(origin: GeoPoint, radiusMi: number): Observable<StoreWithDistanceState[]>;
}

export const STORE_REPOSITORY = new InjectionToken<StoreRepository>('STORE_REPOSITORY');
